import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const schedule = {
  path: '/neededPills',
  component: Layout,
  name: 'neededPills',
  redirect: '/neededPills/index',
  children: [{
    path: '/neededPills/index',
    component: () => import('@/views/neededPills/index'),
    name: 'neededPills.index',
    meta: {
      title: i18n.t(`message.medicines_on`)
    }
  }, ]
}

export default schedule